var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('email-schedule-form',{attrs:{"data":_vm.emailSchedule}})}
var staticRenderFns = []

export { render, staticRenderFns }